<template>
  <div class="couserView">
    <!-- 课程资料 -->
    <div v-if="ifNew" v-loading="loading" :element-loading-text="'加载中'">
      <el-collapse v-model="openIndex" accordion @change="collapseChange">
        <el-collapse-item v-for="(item, index) in yearsList" :key="index" :name="index">
          <template slot="title">
            <div class="title">
              <div class="shu"></div>
              <div class="title-name">
                {{ item.kcName }}
              </div>
            </div>
            <div class="fenge"></div>
          </template>

          <div class="examPack">
            <div class="list" v-if="courseList && courseList.length > 0">
              <div class="item" v-for="(item, index) in courseList" :key="index" @click="tabId = item.id">
                <div>
                  <img class="item-image" src="@/assets/img/study/pager.png" />
                  <div class="item-content w-650">
                    <div class="item-title ellipsis">{{ item.paperName }}</div>
                    <div class="item-size ellipsis">
                      <div v-for="(items, indexs) in item.labelNameList" :key="indexs">{{ items }}</div>
                    </div>
                  </div>
                </div>
                <div class="keep-learn keep-check" @click="answerClick(item.contactId, item.paperName, 2)">
                  开始答题
                </div>
              </div>
            </div>
            <div class="nothing" v-if="!courseList || courseList.length == 0">
              <!-- <img class="nothing-img" src="@/assets/img/study/noLearn.png" /> -->
              <div class="nothing-text">暂无内容哦~</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="nothing" v-if="!yearsList || yearsList.length == 0">
        <div class="nothing-text">暂无内容哦~</div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from "@/api/bus";
import Vue from "vue";
import { liveEnum } from "@/api/emun";
import { Know } from "@/api/know";
let know = new Know();
import { getInfo } from "@/api/cookies";
import chater from "@/components/Know/course/chater.vue";
import { AnswerClient } from "@/api/task/answerClient";
let answerClient = new AnswerClient();
export default {
  components: { chater },
  data() {
    return {
      liveEnum: liveEnum,
      userInfo: null,
      search: {
        examType: 1, //1试卷包2：试卷
      },
      list: {
        packages: [],
        paperList: [],
      },
      courseList: [], // 课程列表
      yearsList: [], // 数据列表
      currentYear: "", // 当前年份
      yearKc: [], // 年份列表
      openIndex: 0,
      openChil: 0,
      ifNew: true,
      loading: false,
    };
  },
  props: {
    // 课程id
    classesId: {
      type: String,
    },
    // 是否购买
    IsPurchase: {
      type: Boolean,
      default: false,
    },
    // 1 普通线 2 精品线  3 专属线 4 普通线加精品线
    productLine: {
      type: String,
    },
    // 课程包id
    direction: {},
  },
  created() {
    this.userInfo = getInfo();
    this.getList();
  },
  methods: {
    rideo(val) {
      this.search.examType = val;
      this.searchClick();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      await know
        .classesButtonKcDataList({
          classesId: this.classesId,
          coursePackageId: this.direction,
          userid:
            this.userInfo && this.userInfo.id ? this.userInfo.id : undefined,
          type: 2,
        })
        .then((res) => {
          if (res.code == 0) {
            this.yearsList = res.data;
          }
        });
      this.collapseChange(0);
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    /*课程展开  */
    async collapseChange(val) {
      if (!val && val !== 0) return;
      let item = this.yearsList[val];
      const data = [];
      this.loading = true;
      await know
        .getContactPcPageList({ oneLabelId: item.productLine, kcId: item.id })
        .then((res) => {
          this.loading = false;
          if (res.code == 0) {
            this.courseList = res.data;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /*试卷包查看 */
    checkClick(item) {
      let userInfo = getInfo();
      if (!userInfo) {
        Vue.prototype.goLoginView(false);
        return;
      }
      /*     if (this.IsPurchase) { */
      this.$router.push(
        `/all/examPack?packId=${item.id}&classId=${this.classesId}&IsPurchase=${this.IsPurchase}`
      );
      /* } else {
        this.$notify({
          title: "错误",
          message: "未购买，无法查看, 请先去购买",
          type: "error",
          duration: 2000,
        });
      } */
    },
    /* 试卷 */
    answerClick(item, name, examType) {
      answerClient.selectPaperSubjectList(item).then((res) => {
        if (res.code == 0) {
          Vue.prototype.goExam(
            name,
            item,
            examType,
            1,
            this.IsPurchase,
            res.data.paper.seeNum,
            undefined,
            undefined,
            this.classesId,
            this.cardCode
          );
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.couserView {
  padding-bottom: 20px;
  background: #fff;

  .year_wrap {
    min-height: 84px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-left: 32px;
    padding-top: 24px;

    .year_item {
      width: 95px;
      height: 36px;
      border-radius: 8px;
      background-color: #edf0f7;
      color: #565962;
      text-align: center;
      line-height: 36px;
      margin-right: 24px;
      margin-bottom: 20px;
      cursor: pointer;
    }

    .on {
      border: 1px solid #ff5e51;
      background-color: #fff7f6;
      color: #ff5e51;
      font-weight: bold;
    }
  }
}

.typeRadio {
  margin: 24px 32px 12px;
  display: flex;

  .el-divider {
    margin: 0px 24px;
  }

  .item {
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 14px;
    cursor: pointer;
  }

  .on {
    color: #ff5e51;
  }
}

/deep/.el-collapse {
  border: none !important;

  .redRadio {
    display: none;
  }

  .is-active {
    .redRadio {
      display: inline-block;
    }
  }

  .el-icon-arrow-right {
    transform: rotate(90deg);
  }

  .is-active.el-icon-arrow-right {
    transform: rotate(270deg);
  }

  .el-collapse-item__header {
    height: 58px;
    padding: 19px 32px 19px 0px;
    border: none !important;
    position: relative;

    .title {
      display: flex;
      height: 20px;
      align-items: center;

      .title-name {
        font-size: 18px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        display: flex;
        align-items: center;
        margin-right: 20px;

        .iconfont {
          color: #333333;
          font-size: 12px;
          margin-right: 9px;
        }
      }

      .shu {
        width: 4px;
        height: 20px;
        background: #fff;
        border-radius: 0px 2px 2px 0px;
        opacity: 1;
        margin-right: 29px;
      }
    }

    .fenge {
      // width: 816px;
      height: 1px;
      background: #eeeeee;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      position: absolute;
      bottom: 0px;
      left: 32px;
      right: 32px;
    }
  }

  .is-active {
    .shu {
      background: #ff5e51 !important;
    }
  }

  .el-collapse-item__content {
    border: none !important;
    padding-bottom: 0px;
  }

  .el-collapse-item__wrap {
    border: none !important;
  }
}

/* 按章列表 */
/deep/ .docList {
  padding: 0px 32px;

  .el-collapse {
    border: none !important;
  }

  .el-collapse-item__header {
    height: 52px;
    background: #f5f7f9;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    padding: 0px 12px;
    margin-top: 12px;
  }

  .docList-type {
    height: 20px;
    background: #ffffff;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #ff7b1c;
    padding: 0px 6px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular;
    font-weight: 400;
    color: #ff7b1c;
    line-height: 18px;
    flex-shrink: 0;
    margin-right: 8px;
  }

  .docList-title {
    padding: 20px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;

    .title-text,
    .title {
      font-size: 16px;
      font-family: Microsoft YaHei-Regular;
      font-weight: bold;
      color: #333333;
      line-height: 14px;
    }

    .flex-c {
      width: calc(100% - 100px);
    }

    .tips {
      font-size: 12px;
      font-family: Microsoft YaHei-Regular;
      font-weight: 400;
      color: #999999;
      line-height: 12px;
      margin-right: 17px;
      flex-shrink: 0;
    }

    .iconfont {
      font-size: 16px;
      width: 25px;
      height: 25px;
      transform: rotate(-90deg);
      display: inline-block;
      transition: transform 0.4s;
    }
  }

  .open {
    .iconfont {
      transform: rotate(90deg);
      display: inline-block;
      transition: transform 0.4s;
    }
  }

  .uni-collapse-cell__title-text {
    border: none !important;
  }

  .uni-collapse-cell--open {
    .uni-collapse-cell__title-text {
      border: none !important;
    }
  }
}

/* 试卷列表 */
.examPack {
  padding: 0 30px;

  .list {
    width: 100%;
    padding: 0px;
    background: #ffffff;

    .item {
      position: relative;
      height: 112px;
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;
      justify-content: space-between;

      >div:nth-child(1) {
        display: flex;
        align-items: center;
      }

      .item-image {
        width: 60px;
        height: 80px;
        flex-shrink: 0;
        background: #f7f8f9;
        margin-right: 12px;
      }

      .item-content {
        height: 80px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .item-title {
          font-size: 16px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          width: 100%;
        }

        .item-size {
          max-width: 500px;
          display: flex;
          margin-top: 10px;
          overflow-x: hidden;

          >div {
            padding: 1px 4px;
            background: #FFEEED;
            border-radius: 4px 4px 4px 4px;

            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #FF5E51;
            margin-right: 5px;
          }
        }
      }

      .keep-learn {
        flex-shrink: 0;
      }
    }
  }
}

.zhuanshu {
  .item {
    padding: 24px 32px !important;
  }
}

.list-two {
  padding: 0px 32px;
  /* height: 148px; */
  background: #fff;

  .item {
    border-bottom: 1px solid #eee;
    border-radius: 0px;
    height: 148px;
    padding: 0px;
    margin-bottom: 0px;

    .item-content {
      height: 100px;
    }
  }
}

.w-650 {
  width: 650px !important;
}
</style>
